import { CUSTOM_FIELD_KEYS, PageTypeEnum } from '@/constant';
import {
	GetWorkerAssignmentFranchiseListResponse,
	IFranchiseListItem,
} from '@/services';

import {
	filterByPrefixKeyWithFormat,
	formatCustomFieldValueToExcel,
	formatDate,
	insertObjectIfV2,
	map,
} from 'utils';

import { isNotEmpty } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

import { formatWorkerFranchiseListItem } from '../worker-franchise';

export const formatWorkerAssignmentFranchiseListItem = (
	input: GetWorkerAssignmentFranchiseListResponse['content'][number]
) => {
	let _input = {
		...input,
	};

	let newFranchiseFormat = filterByPrefixKeyWithFormat<IFranchiseListItem>(
		_input,
		PageTypeEnum.FRANCHISE
	);
	if (isNotEmpty(newFranchiseFormat)) {
		newFranchiseFormat = formatWorkerFranchiseListItem(newFranchiseFormat);
	}

	const formatValues = {
		...newFranchiseFormat,
	} as typeof _input;

	return {
		..._input,
		...insertObjectIfV2(isNotEmpty(formatValues), {
			...formatValues,
		}),
		id: _input?.assignmentFranchiseId,
		assignmentFranchiseStartDate: formatDate(
			_input?.assignmentFranchiseStartDate
		),
		assignmentFranchiseEndDate: formatDate(_input?.assignmentFranchiseEndDate),
		assignmentFranchiseRegistDt: formatDate(
			_input?.assignmentFranchiseRegistDt
		),
		assignmentFranchiseUpdateDt: formatDate(
			_input?.assignmentFranchiseUpdateDt
		),
	};
};

export const formatWorkerAssignmentFranchiseList = (
	input: GetWorkerAssignmentFranchiseListResponse['content']
) => {
	return map(input, formatWorkerAssignmentFranchiseListItem);
};

export const formatWorkerAssignmentFranchiseExcelList = (
	input: GetWorkerAssignmentFranchiseListResponse['content']
) => {
	return map(input, (item) => {
		return {
			...formatWorkerAssignmentFranchiseListItem(item),
			franchiseDistrictId: item?.franchiseDistrictName,
			franchisePublicFranchiseId: item.franchisePublicFranchiseName,
			franchiseProductionScale: isNotNilOrEmpty(item?.franchiseProductionScale)
				? Number(item?.franchiseProductionScale)?.toLocaleString?.('ko-KR')
				: '',

			...formatCustomFieldValueToExcel(
				[...CUSTOM_FIELD_KEYS.franchise].reduce(
					(acc, key) => ({
						...acc,
						[key]: item?.[key as keyof typeof item],
					}),
					{}
				)
			),
		};
	});
};
